import React from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import {Editor} from '../editor-components';
import ReactFireComponent from '../react-fire-component/react-fire-component';

export default class ShowBeneficiaries extends ReactFireComponent {
  constructor(props){
    super(props);
    this.state = {
      affiliates: {},
      beneficiaries: {}
    }
    this.dataURL = props.dataURL + '/beneficiaries';
    this.handleBeneficiaryCheck = this.handleBeneficiaryCheck.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to its firebase realtime
    * database entry
    */
  componentWillMount(){
    this.bindAsObject('affiliates', 'affiliates');
    this.bindAsObject(this.dataURL, 'beneficiaries');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount(){
    this.unbind('affiliates');
    this.unbind('beneficiaries');
  }
  /** @function handleBeneficiaryCheck
    * Adds or removes an affiliate from the
    * show's beneficiary list.
    * @param {InputEvent} event - the event to respond to
    */
  handleBeneficiaryCheck(event) {
    var key = event.target.value;
    var checked = event.target.checked;
    if(checked) {
      firebase.database().ref(this.dataURL).child(key).set({
        category: this.state.affiliates[key].category,
        name: this.state.affiliates[key].organization
      });
    } else {
      firebase.database().ref(this.dataURL).child(key).set(null);
    }
  }
  /** @function handleCheckAll
    * Adds or removes all affiliates from the
    * show's beneficiary list.
    * @param {InputEvent} event - the event to respond to
    */
  handleCheckAll(event) {
    var checked = event.target.checked;
    var affiliates = [];
    Object.keys(this.state.affiliates).forEach(key => {
      let affiliate = this.state.affiliates[key];
      affiliate.id = key;
      affiliates.push(affiliate);
    });
    if(checked) {
      var updates = {};
      affiliates
      .filter(a => (a.organization && !a.group))
      .forEach(affiliate => {
        updates[`${this.dataURL}/${affiliate.id}`] = {
          category: affiliate.category || 'Uncategorized',
          name: affiliate.organization
        };
      });
      firebase.database().ref().update(updates);
    } else {
      firebase.database().ref(this.dataURL).set({})
      // React depends on the default behavior of unchecking checkboxes,
      // so unchecking all doesn't uncheck the individual boxes.  We
      // have to do so manually.
      .then(() => {
        var elements = document.getElementsByTagName('input');
        for(var i=0; i < elements.length; i++){
					if(elements[i].type==='checkbox')
						elements[i].checked=false;
				}
      });
    }
  }
  /** @function render
    * Renders the component
    */
  render() {
    var affiliates = [];
    for(var key in this.state.affiliates) {
      let affiliate = this.state.affiliates[key];
      affiliate.id = key;
      affiliates.push(affiliate);
    }
    const beneficiaries = affiliates
    .filter(a => (a.organization && !a.group))
    .sort((a,b) => a.organization.localeCompare(b.organization))
    .map(affiliate => {
      return (
      <div key={affiliate.id}>
        <label htmlFor={`affiliate-${affiliate.id}`}>
          <input type="checkbox"
            value={affiliate.id}
            id={`affiliate-${affiliate.id}`}
            checked={this.state.beneficiaries[affiliate.id] && true}
            onChange={this.handleBeneficiaryCheck}
            />
          {affiliate.organization}
        </label>
      </div>
    )});
    return (
      <Editor>
        <p className="info-panel">
          This list contains all affiliate organizations
          in the Vexpo Platform.  To include an affiliate
          as a beneficiary of this show, check next to the
          beneficiary's name.
        </p>
        <div>
          <label>
            <input type="checkbox" onChange={this.handleCheckAll}/>
            All
          </label>
        </div>
        <hr/>
        {beneficiaries}
      </Editor>
    );
  }
}



// WEBPACK FOOTER //
// ./src/show-editor/show-beneficiaries.js